import { ShieldCheck } from "lucide-react";
import { BRAND_DETAILS } from "../lib/constants";

export default function BrandsSection() {
  return (
    <section
      data-testid="brands-section"
      className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
            <ShieldCheck className="w-4 h-4" /> Marques partenaires
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
            Les marques que nous
            <br />
            <span className="text-teal-600">installons ou réparons.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 flex items-end">
          <p className="text-slate-600 leading-relaxed">
            Nous travaillons exclusivement avec des marques de serrurerie
            reconnues pour leur <strong>fiabilité</strong>, leur{" "}
            <strong>qualité</strong> et leur conformité aux{" "}
            <strong>normes de sécurité</strong> en vigueur. Ce choix rigoureux
            nous permet de garantir des installations durables, performantes et
            parfaitement compatibles avec les exigences des assurances.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {BRAND_DETAILS.map((b, i) => (
          <div
            key={b.name}
            data-testid={`brand-card-${b.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className="group relative rounded-3xl border border-slate-200 bg-white text-slate-900 transition-all overflow-hidden p-6 flex flex-col gap-3 hover:-translate-y-1 hover:border-teal-500 hover:shadow-xl"
          >
            <div className="text-xs font-bold uppercase tracking-widest text-teal-600">
              0{i + 1}
            </div>
            <div className="flex items-center justify-center h-24 rounded-2xl px-4 bg-white border border-slate-100 overflow-hidden">
              <img
                src={b.logo}
                alt={b.name}
                className="max-h-16 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
              {b.tag}
            </div>
            <p className="text-sm leading-relaxed text-slate-600">
              {b.desc}
            </p>
          </div>
        ))}
      </div>

      <p
        data-testid="brands-footer-text"
        className="text-sm text-slate-500 mt-8 italic"
      >
        Chez Mon Serrurier Breton, la qualité du matériel est une priorité pour
        assurer votre sécurité et votre tranquillité.
      </p>
    </section>
  );
}
